module.exports = __webpack_public_path__ + "img/Transports.3e24ea3d.png";